<template>
    <div :class="elementStyle"
         ref="elementBox"
         @click="handleClick"
         tabindex="0"
         @keydown="keyPressExpand"
    >
    
        <i class="icon elementIcon" :class="element.class" v-html="element.icon"></i>          
    </div>
</template>
<!--         v-tooltip.right = "{-->
<!--                content:element.title,-->
<!--                class: 'tooltip-custom',-->
<!--                delay: 100,-->
<!--                visible: !isMenuExpanded-->
<!--            }"-->
<script>
    // import VTitle from 'v-title';
    import { ref, onMounted } from 'vue'
    import 'tippy.js/animations/scale.css';
    import tippy from 'tippy.js';
    import {hideAll} from 'tippy.js';
    import 'tippy.js/dist/tippy.css'; // optional for styling

    export default {
        name: 'SidebarElement',
        props: ['element','isMenuExpanded','ismobile'
        ],
        // data(){
        //   return {
        //     isExpanded:false
        //   }
        // },
        setup(){
          const elementBox = ref(null);
          onMounted(()=>{
            console.log('elementBox');
            console.log(elementBox.value);
          })
          return{
            elementBox
          }
        },
        computed:{
            elementStyle:function () {
                if(this.element.isActive){
                    return 'sidebar-element active';
                }
                return 'sidebar-element';
            }
        },
        mounted(){
          console.clear();
          // const menuExpanded = fromRef(this.isMenuExpanded);
          console.log('this.isMenuExpanded');
          console.log(this.isMenuExpanded);
          const tippyInstance = tippy(this.elementBox, {
              content: this.element.title,
              placement:'right',
              trigger:'mouseenter'
          });
          tippyInstance['vueRefThis'] = this;
          tippyInstance.setProps({
            onShow(instance){
                console.log('instance.vueRefThis');
                console.log(instance.vueRefThis.ismobile);
                console.log('instance.vueRefThis.isMenuExpanded');
                console.log(instance.vueRefThis.isMenuExpanded);
              if(instance.vueRefThis.isMenuExpanded){  //hide tooltip if menu is expanded
                return false;
              }
            }
          });
        },
        methods:{
              handleClick:function () {
                  hideAll(); //from tippy - avoid tooltip overlay the submenu
                  this.$emit('on-expand-element',this.element);
              },
              keyPressExpand:function (evt) {
                console.log('KEY:'+evt.which);
                  if(evt.which===13){

                    hideAll(); //from tippy - avoid tooltip overlay the submenu
                    console.log(evt);
                    this.$emit('on-expand-element',this.element);
                  }
                  if(evt.which===39){
                    this.$emit('on-jump-to-submenu',this.element);
                  }
              }
          }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .vue-tooltip.tooltip-custom {
        background-color: #313A41;
    }
    .vue-tooltip.tooltip-custom .tooltip-arrow {
        border-right-color: #313A41!important;
    }
</style>
<style scoped>
    .sidebar-element {
        border-bottom:1px solid #272E34;
        width:77px;
        height:70px;
        color:#fff;
        text-align:center;
        line-height:70px;
        cursor:pointer;
        padding-right:6px;
        border-left:6px solid #313A41;
    }
    .sidebar-element.active {
        border-left:6px solid #0099BC;
        background-color: #272E34;
    }
    .sidebar-element i.icon{
        font-size:15px;
    }
</style>
